import { atom } from 'jotai';
import { RequestFilter } from './@types';

export const requestFilterAtom = atom<RequestFilter>({});

export const requestScrollTarget = atom<number>(0);